export default __webpack_public_path__ + "static/media/ClockTicking.7e19ba1a.wav";